/// <reference path="../../_ext/Editors/ItemEditorDialog.ts" />
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class RejectionItemsDialog extends _Ext.ItemEditorDialog<RejectionItemsRow> {
        protected getFormKey() { return RejectionItemsForm.formKey; }
        protected getLocalTextPrefix() { return RejectionItemsRow.localTextPrefix; }
        protected getDeletePermission() { return RejectionItemsRow.deletePermission; }
        protected getInsertPermission() { return RejectionItemsRow.insertPermission; }
        protected getUpdatePermission() { return RejectionItemsRow.updatePermission; }

        protected form = new RejectionItemsForm(this.idPrefix);
        // #region Public Variables
        public masterId: number;
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public newLineNo: number;
        public Totals: number;

        // #endregion 

        constructor() {
            super();

            // #region UI
            //Make grid full width
            q.hideEditorLabel(this.form.BOMDetails);
            q.hideEditorLabel(this.form.ImageName);
            //q.HideCategoryLable(this.element);
            // **** Assign Values to BOM and Labor Editor ****
            // this will be used to calculate Rate for RM and Labor while adding new item.
            this.form.BOMDetails.RateListId = this.RateListId;
            //Set Numeric Fields as Right Align
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.DiamondAmount);
            q.setTextRightAlign(this.form.DiamondPieces);
            q.setTextRightAlign(this.form.DiamondWeight);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.OtherAmount);
            q.setTextRightAlign(this.form.OtherWeight);
            q.setTextRightAlign(this.form.OtherPieces);
            q.setTextRightAlign(this.form.UnitRate);
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.StonePieces);
            q.setTextRightAlign(this.form.StoneWeight);
            q.setTextRightAlign(this.form.WstPer);
            q.setTextRightAlign(this.form.WstWt);
            q.setTextRightAlign(this.form.UnitLabour);
            if (this.form.RefTransId.value != undefined || this.form.RefTransItemId.value)
                q.hideEditorToolbar(this.form.BOMDetails);
            else
                q.showEditorToolbar(this.form.BOMDetails);
            // #endregion

            // #region Field Change Events
            this.form.ItemTypeId.changeSelect2(e => {
                this.Setfields();
            });
            // **** On Pieces Change Event **** 
            this.form.Pieces.changeSelect2(e => {
                if (this.entity.ItemTypeId != 101) {
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                    if (parseInt(this.form.CalcOnId.value) == 3) {
                        this.form.NetAmount.value = pieces * parseFloat(this.form.UnitRate.value.toString());
                        this.form.GrossAmount.value = this.form.NetAmount.value;
                    }
                }
                else {
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, true);
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    var netamount = parseFloat(this.form.NetAmount.value.toString());
                    this.form.GrossAmount.value = (pieces * netamount);
                }
            });
            // **** On Weight Change Event **** 
            this.form.Weight.changeSelect2(e => {
                if (this.entity.ItemTypeId != 101) {
                    var weight = parseFloat(this.form.Weight.value.toString());
                    //Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                    if (parseInt(this.form.CalcOnId.value) == 4 || parseInt(this.form.CalcOnId.value) == 5 && this.form.UnitRate.value > 0) {
                        this.form.NetAmount.value = weight * parseFloat(this.form.UnitRate.value.toString());
                        this.form.GrossAmount.value = this.form.NetAmount.value;
                    }
                }
                else {
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, true);
                }
            });

            this.form.UnitRate.changeSelect2(e => {
                if (parseInt(this.form.CalcOnId.value) == 3) {
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    this.form.NetAmount.value = pieces * parseFloat(this.form.UnitRate.value.toString());
                    this.form.GrossAmount.value = this.form.NetAmount.value;
                }
                else if (parseInt(this.form.CalcOnId.value) == 4 || parseInt(this.form.CalcOnId.value) == 5) {
                    var weight = parseFloat(this.form.Weight.value.toString());
                    this.form.NetAmount.value = weight * parseFloat(this.form.UnitRate.value.toString());
                    this.form.GrossAmount.value = this.form.NetAmount.value;
                }
            });

            this.form.CalcOnId.changeSelect2(e => {
                if (this.entity.ItemTypeId != 101) {
                    var weight = parseFloat(this.form.Pieces.value.toString());
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                    if (parseInt(this.form.CalcOnId.value) == 4 || parseInt(this.form.CalcOnId.value) == 5) {
                        this.form.NetAmount.value = weight * parseFloat(this.form.UnitRate.value.toString());
                    } else {
                        var pieces = parseInt(this.form.Pieces.value.toString());
                        if (parseInt(this.form.CalcOnId.value) == 3) {
                            this.form.NetAmount.value = pieces * parseFloat(this.form.UnitRate.value.toString());
                        }
                    }
                }
                else {
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, true);
                }
            });
            this.form.HasBom.changeSelect2(e => {
                if (this.form.HasBom.value == true) {
                    this.entity.ItemTypeId = 101;
                    this.Setfields();
                    q.showEditorToolbar(this.form.BOMDetails);
                } else {
                    this.entity.ItemTypeId = 104;
                    this.Setfields();
                    //this.form.BOMDetails.destroy();

                }
            });
            // **** On NetAmount Change Event ****
            this.form.NetAmount.changeSelect2(e => {
                var pieces = parseInt(this.form.Pieces.value.toString());
                var netamount = parseFloat(this.form.NetAmount.value.toString());
                this.form.GrossAmount.value = (pieces * netamount);
            });



            // **** On Wastage % Change Event **** 
            this.form.WstPer.changeSelect2(e => {
                this.form.WstWt.value = this.form.NetWeight.value * ((this.form.WstPer.value) / 100);

            });

            this.form.CategoryId.changeSelect2(e => {
                this.form.SubCategoryId.cascadeField = "CategoryId";
                this.form.SubCategoryId.cascadeValue = this.form.CategoryId.value;

            });

            // **** Set Stone Type in SubType ****
            this.form.ProductTypeId.changeSelect2(e => {

                this.form.ItemTypeId.value = OMS.ProductTypeRow.getLookup().itemById[parseInt(this.form.ProductTypeId.value)].ItemTypeId;
                this.entity.ItemTypeId = this.form.ItemTypeId.value;

                if (this.form.ProductTypeId.value == "11") {
                    this.form.SubCategoryId.cascadeField = "CategoryId";
                    this.form.SubCategoryId.cascadeValue = "124";
                }
                if (this.form.ProductTypeId.value == "12") {
                    this.form.SubCategoryId.cascadeField = "CategoryId";
                    this.form.SubCategoryId.cascadeValue = "125";
                }

                this.Setfields();

                var vouchertypeid = (this.parentEditor.parentDialog as RejectionDialog).form.VoucherTypeId.value;
                var VoucherDetails = Q.first(OMS.VoucherMasterRow.getLookup().items, x => x.VoucherTypeId == vouchertypeid);


                switch (this.form.ItemTypeId.value) {
                    case 101:
                        this.form.DepartmentId.value = VoucherDetails.DefaultJewelleryDepartment;
                        break;
                    case 104:
                        this.form.DepartmentId.value = VoucherDetails.DefaultMetalDepartment;
                        break;
                    case 105:
                        this.form.DepartmentId.value = VoucherDetails.DefaultStoneDepartment;
                        break;
                }
            });

            // **** On Labor Rate Change Event **** 
            this.form.UnitLabour.changeSelect2(e => {
                this.form.NetAmount.value = parseFloat(this.form.UnitRate.value.toString()) + parseFloat(this.form.UnitLabour.value.toString());
                if (this.form.Pieces.value != null) {
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    var netamount = parseFloat(this.form.NetAmount.value.toString());
                    this.form.GrossAmount.value = (pieces * netamount);
                }
            });

            // **** On Product Code Change Event **** 
            //Validate Product Code for Duplication 

            this.form.ProductCode.changeSelect2(e => {
                try {
                    let id;
                    OMS.ProductMasterService.CustomList({ ProductCode: this.form.ProductCode.value.toUpperCase() },
                        response => {
                            id = response.Entities[0];
                        }, { async: false });
                    if (id != undefined) {
                        if (id.ProductId != null || id.ProductId > 0) {
                            Q.notifyError("Duplicate Product Code " + this.form.ProductCode.value);
                            this.form.ProductCode.value = "";
                            this.form.ProductCode.element.focus();
                            return;

                        }
                    }
                    else {
                        this.form.ProductCode.value = this.form.ProductCode.value.toUpperCase();
                    }
                }
                catch (undefined) {

                }
            });

            // **** Set Solitaire Fields ****
            this.form.SubCategoryId.changeSelect2(e => {
                var SubCatDetails = OMS.SubCategoryMasterRow.getLookup().itemById[parseInt(this.form.SubCategoryId.value)];
                this.form.CalcOnId.value = SubCatDetails.CalcOnId.toString();
                this.form.CategoryId.value = SubCatDetails.CategoryId.toString();
                this.form.CalcUnitId.value = SubCatDetails.CalcUnitId.toString();

                this.Setfields();
            });

            // #endregion
 
            (this.form.BOMDetails.view as any).onDataChanged.subscribe(() => {
                if (this.form.ItemTypeId.value == 101)
                    this.CalculateTotals();
            });

        }

        // #region Open Dialog, Close Dialog etc

        //// **** Calculate Amount, Tax etc ****
        //private CalculateTotals() {
        //    if (this.form.ItemTypeId.value != null) {
        //        var Pcs = 0, Wt = 0, othrpcs = 0, othrwt = 0, clrpcs = 0, clrwt = 0, diapcs = 0, diawt = 0, grswt = 0, cts = 0, gms = 0, rate = 0;
        //        for (var k of this.form.BOMDetails.getItems()) {

        //            if (k.ItemTypeId == 104) {
        //                Wt += k.Weight;
        //            }
        //            if (k.ItemTypeId == 105 && k.CalcOnId == 5) {
        //                cts += k.Weight;
        //                diapcs += k.Pieces
        //            }
        //            if (k.ItemTypeId == 105 && k.CalcOnId == 4) {
        //                gms += k.Weight;
        //                clrpcs += k.Pieces;
        //            }

        //            rate += k.BomAmount;

        //        }
        //        this.form.NetWeight.value = Wt;
        //        this.form.OtherPieces.value = othrpcs || 0;
        //        this.form.StonePieces.value = clrpcs || 0;
        //        this.form.StoneWeight.value = gms;
        //        this.form.DiamondPieces.value = diapcs || 0;
        //        this.form.DiamondWeight.value = cts || 0;
        //        this.form.OtherWeight.value = 0;
        //        this.form.WstPer.value = 0;
        //        this.form.WstWt.value = 0;

        //        if (cts > 0)
        //            this.form.Weight.value = Wt + gms + (cts / 5);
        //        else
        //            this.form.Weight.value = Wt + gms;
        //        this.form.UnitRate.value = rate / this.form.Pieces.value;
        //        this.form.NetAmount.value = this.form.UnitRate.value + this.form.UnitLabour.value;

        //        if (this.form.Pieces.value != null) {
        //            var pieces = parseInt(this.form.Pieces.value.toString());
        //            var netamount = parseFloat(this.form.NetAmount.value.toString());
        //            this.form.GrossAmount.value = (pieces * netamount);
        //        }
        //    }
        //}

        // **** Dialog open event to set fields as per Item ****
        protected onDialogOpen() {
            super.onDialogOpen();

            this.Setfields();
        }

        // **** Load Entity event to set fields values ****
        protected afterLoadEntity() {
            super.afterLoadEntity();
            this.form.ItemTypeId.value = this.entity.ItemTypeId;
            if (this.entity.ItemTypeId != 101) {
                this.form.UnitRate.value = this.entity.UnitRate;
                if (this.entity.ItemTypeId == 104) {
                    this.form.Purity.value = this.entity.Purity;
                    if (this.form.Purity.value != null)
                        this.form.NetAmount.value = (this.entity.UnitRate * this.entity.Purity) * this.entity.Weight;
                }
                this.form.Pieces.value = this.entity.Pieces;
            }
            this.Setfields();

        }

        // **** Method to set fields as per Item Type Called from various Events ****
        private Setfields() {


            //q.showAndSetRequiredField(this.form.ProductTypeId);
            //q.showAndSetRequiredField(this.form.ProductCode);
            //q.showAndSetRequiredField(this.form.HSN);
            //q.showAndSetRequiredField(this.form.ProductName);
            // **** Hide Jewellery Fields **** //
            if (this.entity.ItemTypeId != 101) {
                Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                q.hideField(this.form.BOMDetails);
                q.hideField(this.form.BrandId);
                q.hideField(this.form.MetalId);
                q.hideField(this.form.CollectionId);
                q.hideField(this.form.SuperTypeId);
                q.hideField(this.form.UnitLabour);
                q.hideField(this.form.NetWeight);
                q.hideField(this.form.DiamondPieces);
                q.hideField(this.form.DiamondWeight);
                q.hideField(this.form.StonePieces);
                q.hideField(this.form.StoneWeight);
                q.hideField(this.form.OtherWeight);
                q.hideField(this.form.OtherPieces);
                q.hideField(this.form.WstPer);
                q.hideField(this.form.WstWt);
                //  q.hideField(this.form.StockId);
                q.hideField(this.form.Line_No);
                q.hideField(this.form.SKU);
                q.hideField(this.form.CategoryId);
                //  q.hideField(this.form.RefVoucherId);
                q.hideEditorTab(this.form.BOMDetails);
                q.hideEditorTab(this.form.ImageName);

                // **** Metal Fields **** //
                if (this.form.ProductTypeId.value == "5" || this.form.ProductTypeId.value == "6" || this.form.ProductTypeId.value == "7") {
                    q.showAndSetRequiredField(this.form.KaratId);
                    q.showAndSetRequiredField(this.form.MetalColorId);
                    q.showAndSetRequiredField(this.form.Purity);

                    q.hideField(this.form.ShapeId);
                    q.hideField(this.form.QualityId);
                    q.hideField(this.form.StoneColorId);
                    q.hideField(this.form.StoneSizeId);
                    q.hideField(this.form.Pieces);

                    if (this.form.ItemTypeId.value == 0)
                        this.form.ItemTypeId.value = 104;

                    if (this.form.CategoryId.value.length == 0)
                        this.form.CategoryId.value = "123";

                    switch (this.form.ProductTypeId.value) {
                        case "5":
                            this.form.SubCategoryId.value = "301";
                            break;
                        case "6":
                            this.form.SubCategoryId.value = "302";
                            break;
                        case "7":
                            this.form.SubCategoryId.value = "303";
                            break;
                    }

                }

                // **** Metal Fields **** //
                if (this.form.ProductTypeId.value == "11" || this.form.ProductTypeId.value == "12" || this.form.ProductTypeId.value == "13") {
                    q.showAndSetRequiredField(this.form.SubCategoryId);
                    q.showAndSetRequiredField(this.form.ShapeId);
                    q.showAndSetRequiredField(this.form.QualityId);
                    q.showAndSetRequiredField(this.form.StoneColorId);
                    q.showAndSetRequiredField(this.form.StoneSizeId);


                    q.hideField(this.form.KaratId);
                    q.hideField(this.form.MetalColorId);
                    q.hideField(this.form.Purity);


                    if (this.form.ItemTypeId.value == 0)
                        this.form.ItemTypeId.value = 105;

                    if (this.form.CategoryId.value.length == 0)
                        this.form.CategoryId.value = "124";
                    this.form.SieveId.value = "131";

                    if (this.form.SubCategoryId.value == "348") {
                        q.hideField(this.form.StoneCutId);
                        q.hideField(this.form.StonePolishId);
                        q.hideField(this.form.StoneSymmetryId);
                        q.hideField(this.form.StoneFluorescenceId);
                        q.hideField(this.form.StoneCuletId);
                        q.hideField(this.form.StoneGirdleId);
                        q.hideField(this.form.StoneTable);
                        q.hideField(this.form.StoneDepth);
                        q.hideField(this.form.CertificateNo);

                    }
                    // **** Solitaire **** //
                    if (this.form.SubCategoryId.value == "349") {
                        q.showAndSetRequiredField(this.form.StoneCutId);
                        q.showAndSetRequiredField(this.form.StonePolishId);
                        q.showAndSetRequiredField(this.form.StoneSymmetryId);
                        q.showAndSetRequiredField(this.form.StoneFluorescenceId);
                        q.showAndSetRequiredField(this.form.StoneCuletId);
                        q.showAndSetRequiredField(this.form.StoneGirdleId);
                        q.showAndSetRequiredField(this.form.StoneTable);
                        q.showAndSetRequiredField(this.form.StoneDepth);
                        q.showAndSetRequiredField(this.form.CertificateNo);
                        q.showAndSetRequiredField(this.form.Pieces);
                        q.showAndSetRequiredField(this.form.Weight);
                        q.showAndSetRequiredField(this.form.Lab);

                    }
                }
            }

            else {
                if (this.entity.ProductId == null || this.entity.ProductId == 0 || this.entity.ProductId == null) {
                    Purchase.PurchaseMasterService.GetLineNo({}, response => this.form.Line_No.value = response.Line_No.toString(), {
                        async: false
                    });
                }
                q.hideEditorTab(this.form.BOMDetails, false);
                q.hideEditorTab(this.form.ImageName, false);

                q.showAndSetRequiredField(this.form.BOMDetails);
                q.showAndSetRequiredField(this.form.BrandId);
                q.showAndSetRequiredField(this.form.CollectionId);
                q.showAndSetRequiredField(this.form.SuperTypeId);
                q.showAndSetRequiredField(this.form.MetalId);
                q.showAndDisableField(this.form.UnitLabour);
                q.showAndDisableField(this.form.NetWeight);
                q.showAndDisableField(this.form.DiamondPieces);
                q.showAndDisableField(this.form.DiamondWeight);
                q.showAndDisableField(this.form.StonePieces);
                q.showAndDisableField(this.form.StoneWeight);
                q.showAndDisableField(this.form.OtherWeight);
                q.showAndDisableField(this.form.OtherPieces);
                q.showAndDisableField(this.form.WstPer);
                q.showAndDisableField(this.form.WstWt);
                //  q.hideField(this.form.StockId);
                q.showAndSetRequiredField(this.form.Line_No);
                q.showField(this.form.SKU);
                q.showAndSetRequiredField(this.form.CategoryId);
            }

        }

        protected onSaveSuccess() {
            // To update Attribute Column in Item Details
            switch (this.form.ItemTypeId.value) {
                case 101:
                    this.form.Attribute.value = "";
                    break;
                case 104:
                    this.form.Attribute.value = "";
                    break;
                case 105:
                    this.form.Attribute.value = "";
                    break;

            }
            this.Totals = 1;
        }
    }
}